import { useTranslation } from 'react-i18next'
import { Card, CardBody } from '../components/ui/Card'
import { PageScrollArea, PageView } from '../components/ui/PageScrollArea'
import { PageHeader } from '../components/ui/PageHeader'
import { ComingSoonPreview } from '../components/ComingSoonPreview'
import { COMING_SOON_VOTE_FEATURE } from '../lib/previewVoteFeature'

// Matches the prototype's `section-mlimits` — a Preview-only page, no real
// backend behind it (see ARCHITECTURE_DECISIONS.md).
export function MonthlyLimits() {
  const { t } = useTranslation()
  return (
    <PageView>
      <PageHeader title={t('monthlyLimits.title')} subtitle={t('monthlyLimits.subtitle')} />
      <PageScrollArea>
        <Card>
          <CardBody>
            <ComingSoonPreview
              title={t('monthlyLimits.title')}
              description={t('monthlyLimits.description')}
              feature={COMING_SOON_VOTE_FEATURE.monthlyLimits}
            />
          </CardBody>
        </Card>
      </PageScrollArea>
    </PageView>
  )
}
